//  @/store/modules/app.js
import Vue from 'vue'

const state = {
  }
  
  const mutations = {
    SET_LISTENER (state, listener) {
      state.listener = listener
    },
    SET_ITEM (state, doc) {
      const data = doc.data()
      state = {
        ...state, 
        [doc.id]: data
      }
    },
    UPDATE_ITEM (state, doc) {
      state[doc.id] = doc.data()
    },
    DELETE_ITEM (state, doc) {
      Vue.delete(state, doc.id)
    },
  }

  const getters = {}
  
  const actions = {
    async init({ commit, state, rootState }) {
      commit('SET_LISTENER', 
      rootState.db.collection('quotes').onSnapshot(snapshot => {
        let changes = snapshot.docChanges()
        changes.forEach(change => {
          let type = change.type
          let doc = change.doc
          
          if(type === 'added') commit('SET_ITEM', doc)
          else if(type === 'modified') commit('UPDATE_ITEM', doc)
          else if(type === 'removed') commit('DELETE_ITEM', doc)
        })
      }, (error) => {console.log(error.message)}))
    },
    async add({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data.updates = [ update ]

      let response = await rootState.db.collection('quotes').add(data)
      return response
    },
    async set({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data[1].updates = [ ...data[1].updates, update ]

      let ref = rootState.db.collection('quotes').doc(data[0])
      let response = await ref.set(data[1])
      return response
    },
    async delete({ rootState }, id) {
      let response = await rootState.db.collection('quotes').doc(id).delete()
      return response
    },
  }
  
  export default { 
    namespaced: true, state, mutations, getters, actions
  }